"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RepayPlanRequest = void 0;
var RepayPlanRequest = /** @class */ (function () {
    function RepayPlanRequest() {
    }
    return RepayPlanRequest;
}());
exports.RepayPlanRequest = RepayPlanRequest;
;
//# sourceMappingURL=repayPlan.request.js.map